import configuration from '@/configuration';
import { UserType, PaginationArgsType, Pagination } from '@/@types';
import { gql } from './_utils';
import { NamespaceArgsType } from './@types';

type UserFiltersType = {
  level?: string;
  text?: string;
};

const userFields = gql`
  fragment UserFields on User {
    id
    name
    nickname
    lastname
    avatar
    email
    level {
      id
      name
    }
    biography
    follows {
      total
    }
    followers {
      total
    }
    isFollowed
    isFollower
    links {
      type
      url
      name
    }
    verified
    language
    country
  }
`;

export const User = ({ graphqlRequest }: NamespaceArgsType) => {
  return {
    oauth: async (provider: string, code: string) => {
      return graphqlRequest<{ User: { login: null | { token: string; user: UserType } } }>({
        query: gql`
          query Login($oauth: OauthInputType!) {
            User {
              login(oauth: $oauth) {
                token(oldFormat: true)
                user {
                  id
                  name
                  email
                  level {
                    id
                    name
                  }
                }
              }
            }
          }
        `,
        variables: {
          oauth: { provider, code, redirectUri: `${configuration.host}/user/oauth/${provider}` },
        },
      });
    },
    find: async ({ filters, pagination }: { filters?: UserFiltersType; pagination?: PaginationArgsType }) => {
      return graphqlRequest<{ User: { find: Pagination<UserType> } }>({
        query: gql`
          query findUsers($filters: UserFilters, $pagination: PaginationUserSortByArgs) {
            User {
              find(filters: $filters, pagination: $pagination) {
                total
                edges {
                  node {
                    id
                    avatar
                    nickname
                    name
                    lastname
                    level {
                      id
                      name
                    }
                    isFollowed
                  }
                }
              }
            }
          }
        `,
        variables: { filters, pagination },
      });
    },
    get: (id: string) => {
      return graphqlRequest<{ User: { get: UserType } }>({
        query: gql`
          query getUser($id: ID!) {
            User {
              get(id: $id) {
                ...UserFields
              }
            }
          }
          ${userFields}
        `,
        variables: { id },
      });
    },
  };
};
